<template>
	<div>
		<container-os ref="CntOS">
			<item-os
				v-for="(itemOs, index) in preRequestData"
				:key="index"
				:cod="itemOs.cod"
				:label="itemOs.tarefa"
				:pInit="itemOs.dInicio"
				:rInit="itemOs.dComeco"
				:pTerm="itemOs.duracao"
				:rTerm="itemOs.dTermino"
			/>
		</container-os>
		<!-- <pre>{{gridInterval}}</pre> -->
	</div>
</template>
<script>
	import ContainerOs from './components/container-os.vue';
	import ItemOs from './components/item-os.vue';

	export default {
		components: {
			ContainerOs,
			ItemOs,
		},
		props: ['preRequestData', 'totalRegistros'],
		watch: {
			preRequestData: function (val) {
				setTimeout((e) => {
					this.$refs.CntOS.update();
				}, 250);
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/order-of-service/components/GraficMode/index.vue